import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-[1fr_auto] gap-6" }

import { watch, ref, nextTick } from 'vue';
import { useRoute } from 'vue-router';

import Card from 'primevue/card';

import CalculationItemsPreview from '../components/CalculationItemsPreview.vue';
import CalculationItems from '../components/CalculationItems.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationItemsView',
  setup(__props) {

const wrapper = ref<HTMLElement | null>(null);

const route = useRoute();
watch(
  () => route.params,
  (newVal, oldVal) => {
    nextTick(() => {
      if (wrapper.value) {
        const target = wrapper.value.querySelector('.p-step.p-step-active');
        setTimeout(() => {
          target?.scrollIntoView();
        }, 200);
      }
    });

    if (newVal.groupId === oldVal?.groupId) return;

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  },
  {
    deep: true,
  }
);

watch(
  wrapper,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        const target = newVal.querySelector('.p-step.p-step-active');
        target?.scrollIntoView();
      });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "h-max max-h-[70vh] overflow-y-auto border border-gray-200 !shadow-none" }, {
      content: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("section", {
          ref_key: "wrapper",
          ref: wrapper
        }, [
          _createVNode(CalculationItems)
        ])), [
          [_directive_auto_animate]
        ])
      ]),
      _: 1
    }),
    _createVNode(CalculationItemsPreview, { class: "max-h-[70vh] min-w-[480px] overflow-y-auto" })
  ])), [
    [_directive_auto_animate]
  ])
}
}

})